<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-users-cog"
      texto-titulo="Listado de Usuarios"
      :to-create-action="{name:'NuevoUsuario'}"
      to-create-text="Nuevo Usuario"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList url="/users" :fields="fields" :row-click="goToEdit" ref="datatable"></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import DataList from '@/components/layouts/DataList'

export default {
  name: "ListarUsuarios",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      usuarios: [],
      fields: [
        {
          name: "denominacion",
          label: "Denominación",
          append: "-",
          type: "title",
          class: "text-primary opacity-10"
        },
        {
          name: "nombre",
          label: "Nombre",
          type: "title",
          class: "text-success opacity-10"
        },
        {
          name: "documento",
          label: "N° documento",
          type: "field",
          class: ""
        },
        {
          name: "tipo",
          label: "Tipo",
          type: "field",
          class: ""
        },
        {
          name: "estado",
          label: "Estado",
          type: "field",
          class: ""
        }
      ],
      loading: false
    };
  },
  mounted() {
  },
  methods: {
    goToEdit(usuario) {
      this.$router.push({name: 'EditarUsuario', params: {id: usuario.id}})
    }
  }
}
</script>
